import { BREAKPOINTS } from "@/settings";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "usehooks-ts";

import { BannerStructure } from "../RootBanner";

export const MyClubBanner = ({
  onClickLeft,
  onClickRight,
}: {
  onClickLeft: () => void;
  onClickRight: () => void;
}) => {
  const navigate = useNavigate();
  const handleOnClickCTA = () => {
    navigate("/subscription");
  };
  const isTouchDevice = useMediaQuery(BREAKPOINTS.TOUCH_DEVICE.query);
  return (
    <BannerStructure
      bgUrl="bg-[url('https://cdn.easysbc.io/fc25/banners/myclubbanner/myclubbanner.png')]"
      title={
        <span>
          Stop wasting your time and coins. <br /> Get SBC solutions with your
          own club.
        </span>
      }
      onClickCTA={handleOnClickCTA}
      onClickLeft={onClickLeft}
      onClickRight={onClickRight}
      learnMoreLink="/get-sbc-solver"
    >
      <div
        className="h-full w-full absolute bottom-0 touch-device:hidden"
        style={{
          background:
            "linear-gradient(0deg, #281B16 43.65%, rgba(73, 17, 37, 0.00) 100%)",
        }}
      />
      <div
        className="absolute w-full h-full hidden touch-device:block"
        style={{
          background:
            "linear-gradient(90deg, rgba(28, 11, 21, 0.50) 50.65%, rgba(73, 17, 37, 0.00) 100%)",
        }}
      />
      <img
        className="absolute h-68 object-cover touch-device:h-64 large-desktop:h-[327px] touch-device:right-0 touch-device:top-12 top-2"
        src={`${import.meta.env.VITE_APP_ASSETS_BASE_URL}${
          isTouchDevice
            ? "/fc25/banners/myclubbanner/myclubbannermobile2.png"
            : "/fc25/banners/myclubbanner/myclubbannergraphic.png"
        }`}
        alt="myclubbanner"
      />
    </BannerStructure>
  );
};
